<script setup>
import Popup from './popup.vue';
import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal';
</script>

<script>
export default {
  components: {
      Popup,
   },
  data: () => ({
    popupshow: false,
    clientObj :{},
    Settings : {"Type":"","ForwardToNumber":"","IncomingNumber":"",DisplayNumber:"","EmailAddress":"","OxygenNumber":""},
    meetingInfo:{},
    watchMeeting:{}
  }),
  mounted() {

  },
  computed:{
  },
  methods: {
    showMeetingInfo : function(clientID) {
     console.log("show meeting info called",clientID);
      let client = window.botStore.getClientByID(clientID);
      let MeetingContext = JSON.parse(client.MeetingContext);
      let MeetingURL = JSON.parse(client.MeetingURL);
      let LocationContext = JSON.parse(client.LocationContext);
      //console.log("Meeting Context",MeetingContext);
      //console.log("Meeting URL",MeetingURL);
      this.meetingInfo.MeetingId = MeetingContext.MeetingId;
      this.meetingInfo.MeetingPE = MeetingContext.MeetingPE;
      this.meetingInfo.MeetingRole = MeetingContext.MeetingRole;
      this.meetingInfo.ShortURL  = MeetingURL.ShortURL;
      
      let URLContext = {
					onLoad : [
						{ open : "true", child : { DisplayName : "Media-Player", Termination : { MediaType : "Iframe", URL : "/GraphsApp/GraphMediaPlayer/index.html?clientID="+clientID}}}
					]
				};
      let params = {
        method : "POST",
        type : "application/json",
        url : "/BotServices/bot/getSignedUrl",
        data : {
          URL : LocationContext.origin + '/DeviceManager/index.html?MeetingContext='+client.MeetingContext,
          Component : client.ClientRight,
          //Role : 'Client.ClientRightRole',
          Role : 'watcher',
          InitialContext : URLContext
        }
      };
      window.BotServices.httpRequest(params, (err, signedUrl) => {
        console.log("setMeetingURL Result : ", signedUrl.ShortURL);
        let req = JSON.parse(signedUrl);
        this.watchMeeting.MeetingURL = req.ShortURL;
      });
    },
    showPopUp : function(clientID) {
      console.log("====show pop up===="+this.popupshow);
      this.popupshow = true;
      this.showMeetingInfo(clientID);
    },
    copyToClipboard :  function() {
        var copyText = document.getElementById("watchmeetshorturl").innerHTML;
        navigator.clipboard.writeText(copyText);

        var tooltip = document.getElementById("watchmyTooltip");
        tooltip.innerHTML = "Copied: " + copyText;
    },
    outFunc : function () {
      var tooltip = document.getElementById("watchmyTooltip");
      tooltip.innerHTML = "Copy to clipboard";
    }
  }
}
</script>

<template>
<v-button style="display:none;" @click="show = true">Open modal</v-button>
<Popup v-model="popupshow" >
<template v-slot:title>Watch</template>
<template v-slot:content>
<form classSW="formbox" >
<div class="meeting-info" style="display:flex;">
<table style="max-height: calc((100vh - 81px) - 75.6px); background-color: rgb(248, 248, 248); color: black;">
    <tr><td colspan="3">
        <span class="label-text">ShortURL</span>
        </td><td colspan="3" style="display:flex;">
        <span class="label-text" id="watchmeetshorturl">{{watchMeeting.MeetingURL}}</span>&nbsp;&nbsp;<div class="tooltipwatch"><span class="far fa-copy" @click="copyToClipboard" @onmouseout="outFunc" style="color:#0072c5;cursor:pointer;"></span><span class="tooltiptextwatch" id="watchmyTooltip">Copy to clipboard</span></div>
    </td></tr>

    <tr><td colspan="3">&nbsp;
        </td><td colspan="3" style="display:flex;">
    &nbsp;</td></tr>
    </table>
  </div>

</form>
</template>

</Popup>
</template>

<style>
.label-text {
    padding: 0 0px;
    font-size: inherit;
    overflow: hidden;
    /*text-overflow: ellipsis;*/
    white-space: nowrap;
    font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
    color: rgba(0, 0, 0, 0.5);font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;margin: 0;background-color: #fff;font-weight: 400;
}
.input-text {
  background-color: white;
  border: 1px solid lightgray;
  width: 100%;
  display: block;
}
.ButtonText{
    margin-left: 145px;
    height: 25px;
    background-color: #0072c5;
    color: #fff;
    white-space: nowrap;
    align-items: center;
    font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
    width:50%;
}

.formbox{
  max-width:460px;
  margin:auto;
  margin-top:35px;
  border:0px solid #2f2f2f;
  padding:24px;
  border-radius:4px;
}
#btn-submit{
  width:100%;
}

.tooltipwatch {
  position: relative;
  display: inline-block;
}
.tooltipwatch .tooltiptextwatch {
    visibility: hidden;
    width: 210px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 6px;
    position: absolute;
    z-index: 1;
    bottom: 150%;
    left: 50%;
    margin-left: -115px;
    opacity: 0;
    transition: opacity .3s;
}
.tooltipwatch .tooltiptextwatch::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}
.tooltipwatch:hover .tooltiptextwatch {
  visibility: visible;
  opacity: 1;
}
</style>
